import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Calendar from 'react-calendar';

import {
  compact,
  get,
  isNaN,
  startCase,
  noop,
} from 'lodash';
import { withStyles } from '@material-ui/core/styles';

import {
  formatPhoneNumber,
  getDeliveryScheduleStatus,
  scrollTo,
  toISO,
  checkDayOnDeliveryWeek,
  isDateOfDeliveryWeeks,
  getActiveStartDate,
} from 'helpers/utils';
import { getAddressOptions } from 'helpers/address';
import {
  injectIntl,
  InvoiceBadge,
  Tooltip,
  Badge,
} from 'components';
import SelectField from 'components/SmartForm/components/SelectField';
import { isMobile } from 'helpers/detect-mobile';
import LocalShipping from '@material-ui/icons/LocalShipping';
import ShowMoreText from 'react-show-more-text';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import LockOutlined from '@material-ui/icons/LockOutlined';
import Paper from '@material-ui/core/Paper';
import Login from '../../Home/components/Login';
import SignUp from '../../Home/components/SignUp';
import qs from 'query-string';


const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: 10,
  },
  datePicker: {
    display: 'inline-block',
    fontSize: 30,
    marginTop: -10,
    textAlign: 'center',
    width: 175,
  },
  pickerInput: {
    fontSize: 20,
    fontWeight: 400,
    width: 175,
  },
  selectFloatingLabel: { width: '120%' },
  selectLabel: { color: 'grey' },
  retailSelectLabel: { fontSize: '14px', color: '#333333' },
  selectRoot: {
    // [theme.breakpoints.down('sm')]: {
    //   maxWidth: '50%',
    // },
    maxWidth: '280px',
  },
  groupsSelectItem: { fontSize: '14px',  whiteSpace: 'break-spaces', height:'40px' },
});

class TopPanel extends Component {
  static contextTypes = {
    isDistributor: PropTypes.bool,
    isFarmer: PropTypes.bool,
    isRestaurant: PropTypes.bool,
    isConsumer: PropTypes.bool,
    isPublic: PropTypes.bool,    
    noAutoPay: PropTypes.bool,
  };

  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    contact: PropTypes.shape({}).isRequired,
    deliveryDate: PropTypes.string,
    fromAddressIndex: PropTypes.number.isRequired,
    toAddressIndex: PropTypes.number.isRequired,

    changeFromAddress: PropTypes.func.isRequired,
    changeToAddress: PropTypes.func.isRequired,
    changeDeliveryType: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired,
    pickDeliveryDate: PropTypes.func.isRequired,
    changeEnableDeliveryFee: PropTypes.func,
    isInvisibleCalendar: PropTypes.bool,
    totalInfo: PropTypes.shape({}),
    boxItems: PropTypes.shape({}),
    history: PropTypes.shape({}).isRequired,
    isShopPage: PropTypes.bool,
    emailAutoFocus: PropTypes.bool,
    deliveryType: PropTypes.string.isRequired,
  };

  static defaultProps = {
    deliveryDate: '',
    isInvisibleCalendar: false,
    totalInfo: null,
    boxItems: null,
    changeEnableDeliveryFee: noop,
    isShopPage: false,
    emailAutoFocus: false,
  };

  state = {
    addressType: this.props.deliveryType,
    selectedAddress: '',
    isDisabledFromAddress: false,
    isDisabledToAddress: false,
    showDeliveryTo: false,
    showPickUp: false,
    movingRight: false,
    movingLeft: false,
    email: '',
    password: '',
    userTypeTab: 'consumer',
  }

  componentWillMount() {
    this.validateDate(this.props, true);
    const { contact } = this.props;
    const { addressType } = this.state;
    const sellerProfile = get(contact, 'sellerProfile');
    if (sellerProfile) {
      const deliveryTo = sellerProfile.deliveryTo;
      const pickUp = sellerProfile.pickUp;
      let newAddressType = addressType;
      if (deliveryTo === true && pickUp === true) {
        this.setState({ showDeliveryTo: true, showPickUp: true });
      } else if (deliveryTo === true && pickUp === false) {
        this.setState({ showDeliveryTo: true, showPickUp: false });
      } else if (deliveryTo === false && pickUp === true) {
        newAddressType = 'pickUp';
        this.setState({ showDeliveryTo: false, showPickUp: true, addressType: newAddressType });
      }
      this.checkedAddressType(newAddressType);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.deliveryDate !== nextProps.deliveryDate) {
      this.validateDate(nextProps);
    }
  }

  validateDate = ({ contact, deliveryDate, pickDeliveryDate } = this.props, delay = false) => {
    const deliverySchedule = contact.sellerProfile.deliverySchedule || [];
    let currentDate = new Date(moment(deliveryDate).local());
    const isInValidDate = isNaN(currentDate.getTime());
    const { enabled } = isInValidDate
      ? {}
      : getDeliveryScheduleStatus(deliverySchedule, currentDate);
    if (isInValidDate || currentDate.getTime() < new Date().setHours(0, 0, 0, 0) || !enabled) {
      currentDate = null;
    }
    if (delay) {
      setTimeout(() => pickDeliveryDate(currentDate), 500);
    } else {
      pickDeliveryDate(currentDate);
    }
  }

  disablePastDays = date =>
    moment(date).diff(moment()) < 0 && moment(date).date() < moment().date();

  checkedAddressType = (value) => {
    const { changeEnableDeliveryFee, changeDeliveryType, pickDeliveryDate } = this.props;

    this.setState({ addressType: value });
    changeDeliveryType(value);
    pickDeliveryDate("");
    if (value === 'deliveryTo') {
      this.setState({ selectedAddress: this.setToAddress(0), isDisabledFromAddress: true, isDisabledToAddress: false });
      changeEnableDeliveryFee(true);
    } else {
      this.setState({ selectedAddress: this.setFromAddress(0), isDisabledFromAddress: false, isDisabledToAddress: true });
      changeEnableDeliveryFee(false);
    }
  }

  selectFromAddress = (event) => {
    const { changeFromAddress } = this.props;
    this.setState({ selectedAddress: this.setFromAddress(event) });
    changeFromAddress(event);
  }

  setFromAddress = (event) => {
    const { contact } = this.props;
    const { sellerProfile } = contact;
    const fromAddress = sellerProfile.addresses ?
      sellerProfile.addresses[event] : {};
    const fullName = `${sellerProfile.firstName} ${sellerProfile.lastName} @`;
    const stateAndZipcode = `${fromAddress.state && fromAddress.city && fromAddress.zipcode ? `${fromAddress.city || ''} ${fromAddress.state || ''} - ${fromAddress.zipcode || ''}.` : ''}`;
    const selectedFromAddress = `@ ${fromAddress.address} ${stateAndZipcode}`;
    return selectedFromAddress;
  }

  selectToAddress = (event) => {
    const { changeToAddress } = this.props;
    this.setState({ selectedAddress: this.setToAddress(event) });
    changeToAddress(event);
  }

  setToAddress = (event) => {
    const { contact } = this.props;
    const { buyerProfile } = contact;
    const toAddress = buyerProfile && buyerProfile.addresses ? buyerProfile.addresses[event] : {};
    const fullName = buyerProfile ? `${buyerProfile.firstName} ${buyerProfile.lastName} @` : '';
    const stateAndZipcode = buyerProfile ? `${toAddress.state && toAddress.city && toAddress.zipcode ? `${toAddress.city || ''} ${toAddress.state || ''} - ${toAddress.zipcode || ''}.` : ''}` : '';
    const selectedToAddress = buyerProfile ? `${fullName} ${toAddress.address} ${stateAndZipcode}` : '';
    return selectedToAddress;
  }

  get showSignup() {
    const {
      isShopPage,
      history,
    } = this.props;

    return isShopPage ? (history.location.hash.split('?')[0] === '#signup' || history.location.hash.split('?')[0] === '') : false;
  }

  switchForms = () => {
    const { isShopPage, history } = this.props;
    const { showSignup } = this;
    if (showSignup) {
      this.setState({ movingLeft: true });
      setTimeout(() => this.setState({ movingLeft: false }), 200);
    } else {
      this.setState({ movingRight: true });
      setTimeout(() => this.setState({ movingRight: false }), 100);
    }
    const { redirect_url: redirectUrl, profileUrl, vendorEmail, asConsumer, deliveryDate, ...rest } = qs.parse(history.location.search.slice(1));
    const encodedUrl = encodeURIComponent(`${history.location.pathname}?${qs.stringify(rest)}`);
    const urlPathname = redirectUrl ? `/?redirect_url=${encodeURIComponent(redirectUrl) || encodedUrl}#` : '';
    const profilePathname = profileUrl ? `/?profileUrl=${encodeURIComponent(profileUrl) || encodedUrl}&vendorEmail=${vendorEmail}#` : '';
    const asConsumerPathname = asConsumer ? `/?asConsumer=${encodeURIComponent(asConsumer)}#` : '';
    setTimeout(() => {
      if (isShopPage) {
        const publicPathname = history.location.pathname;
        const deliveryDatePathname = deliveryDate ? `?deliveryDate=${deliveryDate}` : '';
        history.push(`${publicPathname}${deliveryDatePathname}#${showSignup ? 'login' : 'signup'}`);
      } else if (redirectUrl) {
        history.push(`${urlPathname}${showSignup ? 'login' : 'signup'}`);
      } else if (profileUrl) {
        history.push(`${profilePathname}${showSignup ? 'login' : 'signup'}`);
      } else if (asConsumer) {
        history.push(`${asConsumerPathname}${showSignup ? 'login' : 'signup'}`);
      } else {
        const publicPathname = history.location.pathname;
        history.push(`${publicPathname}#${showSignup ? 'login' : 'signup'}`);
      }
    }, 100);
  }

  setUserTypeTab = (userType) => {
    this.setState({ userTypeTab: userType });
    return userType;
  }

  changeEmail = (email) => {
    this.setState({
      email: email
    });
  }

  changePassword = (password) => {
    this.setState({
      password: password
    });
  }

  render() {
    const {
      classes,
      contact,
      fromAddressIndex,
      toAddressIndex,
      changeFromAddress,
      changeToAddress,
      deliveryDate,
      formatMessage,
      pickDeliveryDate,
      isInvisibleCalendar,
      totalInfo,
      boxItems,
      isShopPage,
      emailAutoFocus,
    } = this.props;
    const { noAutoPay, isConsumer, isPublic } = this.context;
    const { addressType, selectedAddress, isDisabledFromAddress, isDisabledToAddress, showDeliveryTo, showPickUp, movingRight, movingLeft, userTypeTab } = this.state;
    const { showSignup } = this;
    const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
    const { buyerProfile, sellerProfile } = contact;
    const fromAddressList = getAddressOptions(sellerProfile.addresses);
    const filteredFromAddressList = fromAddressList && fromAddressList.length > 0 ? fromAddressList.filter(item => !!item.name) : fromAddressList;
    const fromAddress = sellerProfile.addresses ?
      sellerProfile.addresses[fromAddressIndex] : {};
    const deliverySchedule = sellerProfile.deliverySchedule || [];

    const toAddressList = buyerProfile ? getAddressOptions(buyerProfile.addresses) : [];
    const toAddress = buyerProfile && buyerProfile.addresses ?
      buyerProfile.addresses[toAddressIndex] : {};
    let currentDate = new Date(moment(deliveryDate).local());
    const isInValidDate = isNaN(currentDate.getTime());
    if (isInValidDate) {
      currentDate = null;
    }
    const buyerAddress = buyerProfile && toAddressList && toAddressList.length >= 0 && toAddressList[toAddressIndex] && toAddressList[toAddressIndex].label;
    const shopHeader = get(contact, 'sellerProfile.shopHeader');
    const shopBody = get(contact, 'sellerProfile.shopBody');
    const deliveryHeader = get(contact, 'sellerProfile.deliveryHeader');
    const deliveryBody = get(contact, 'sellerProfile.deliveryBody');

    const SelectDeliverDateLabel = (() => (
      <div className="titles consumer" name="titles" style={{ color: '#AAAAAA' }}>
        <div className="date-picker-title consumer">
          {formatMessage(`${addressType === 'deliveryTo' ? 'Delivery' : 'Pick-Up'} Date`)}: <span style={isConsumer ? { color: '#4196f2', fontWeight: '600' } : { color: 'red' }}>{isInValidDate ? '' : moment(currentDate).local().format('DD MMM YYYY')}</span>
        </div>
      </div>
    ))
    const deliveryMsgNotLoggedUser = 'Marin, SF, Berkeley and Oakland. Delivery Fee $10';
    const activeStartDate = getActiveStartDate(deliverySchedule);

    const DeliveryInfo = (() => (
      <div className="delivery-info-section" style={{width: '100%'}}>
        <div className="top-message">
          <span className="title font-grey" style={{ marginTop: 30 }}> { isMobile ? formatMessage('1. Delivery or Pick-up') : formatMessage('1. Set Location')}</span>
        </div> 
        <div className="row radio-group-wrap" style={{width: '100%'}}>
            <RadioGroup
              className="delivery-info"
              name="accountHolderType"
              onChange={e => this.checkedAddressType(e.target.value)}
              value={addressType}
              row
            >
              <FormControlLabel
                style={{marginLeft: 0, marginBottom: isMobile ? 15: 0}}
                control={<Radio color="primary" />}
                label={formatMessage('Pick-Up')}
                value="pickUp"
              />
              <div style={{ display: `${!showPickUp ? 'none' : 'inherit'}` }}>
                <SelectField
                  disabled={isDisabledFromAddress}
                  classes={{
                    item: { root: classes.groupsSelectItem },
                    root: { root: classes.selectRoot },
                    label: { root: classes.selectFloatingLabel },
                    select: { select: (isConsumer || isPublic) ? classes.retailSelectLabel : classes.selectLabel },
                  }}
                  defaultValue={fromAddressIndex}
                  fullWidth
                  name="pickUpAddress"
                  onChange={e => this.selectFromAddress(e)}
                  options={fromAddressList}
                />
              </div>
              <FormControlLabel
                style={{marginLeft: isMobile ? 0 : 40, marginBottom: isMobile ? 15 : 0}}
                control={<Radio color="primary" />}
                label={formatMessage('Delivery')}
                value="deliveryTo"
              />
              <div style={{ display: `${!showDeliveryTo  ? 'none' : 'inherit'}`, paddingRight: '0' }}>
                { toAddressList.length === 0 ? (
                  <div style={{ fontSize: '14px', margin: 'auto' }}>
                    {formatMessage(deliveryMsgNotLoggedUser)}
                  </div>
                ): (
                  <SelectField
                    disabled={isDisabledToAddress}
                    classes={{
                      root: { root: classes.selectRoot },
                      label: { root: classes.selectFloatingLabel },
                      select: { select: (isConsumer || isPublic) ? classes.retailSelectLabel : classes.selectLabel },
                    }}
                    defaultValue={toAddressIndex}
                    fullWidth
                    name="deliveryToAddress"
                    onChange={e => this.selectToAddress(e)}
                    options={toAddressList}
                  />
                )
                }
                
              </div>
            </RadioGroup>
        </div>
      </div>
    ));

    const SelectedDeliveryDate = (() => (
      <div className="delivery-date-and-info">
        {(isConsumer || isPublic) && !isInvisibleCalendar && (
          <SelectDeliverDateLabel />
        )}
      </div>
    )); 

    const TotalsInfo = (() => (
      <div className="delivery-date-and-info">
        <div>{totalInfo}</div>
      </div>
    ));


    return (
      <div className="top-panel">
        <div className="first-pane">
          <div className="from-to-blocks">
            <div className="from-to-block" style={{ display: 'block' }}>
              <div>
                <div className="d-md-none d-xs-block"><b>{buyerProfile.companyName}</b></div>
                {
                  buyerProfile.addresses && (
                    <div className="d-md-none d-xs-block">
                      <SelectField
                        classes={{
                          root: { root: classes.selectRoot },
                          label: { root: classes.selectFloatingLabel },
                          select: { select: classes.selectLabel },
                        }}
                        defaultValue={toAddressIndex}
                        fullWidth
                        name="address"
                        onChange={e => changeToAddress(e)}
                        options={toAddressList}
                      />
                    </div>
                  )}
              </div>
              <div>
                <div className="d-none d-md-block" style={{fontSize: 18}}>{buyerProfile.companyName}</div>
                <div>{buyerProfile.firstName ?
                  (`${buyerProfile.firstName} ${buyerProfile.lastName ?
                    buyerProfile.lastName : ''}`) : buyerProfile.lastName ?
                    buyerProfile.lastName : ''}
                </div>
                {
                  buyerProfile.addresses && (
                    <div className="d-none d-md-block">
                      <SelectField
                        classes={{
                          root: { root: classes.selectRoot },
                          label: { root: classes.selectFloatingLabel },
                          select: { select: classes.selectLabel },
                        }}
                        defaultValue={toAddressIndex}
                        fullWidth
                        name="address"
                        onChange={e => changeToAddress(e)}
                        options={toAddressList}
                      />
                    </div>
                  )}
                <div className="d-md-none d-xs-block">
                  {[
                    toAddress.address,
                    toAddress.city,
                    toAddress.state && toAddress.zipcode ? `${toAddress.state || ''} - ${toAddress.zipcode || ''}` : '',
                  ].join(', ')
                  }
                </div>
                <div className="d-none d-md-block">
                  <div style={{ maxWidth: '300px' }}>{toAddress.address}</div>
                  <div>{toAddress.city}</div>
                  <div>{toAddress.state && toAddress.zipcode ? `${toAddress.state || ''} - ${toAddress.zipcode || ''}` : ''}</div>
                </div>
                <div className="email"><span className="d-lg-down-none">{formatMessage('Email')}: </span>{buyerProfile.email}</div>
                <div className="bottom-gap">
                  {formatMessage('Phone')}: {formatPhoneNumber(buyerProfile.phone1)}
                </div>
              </div>
            </div>
          </div>
          {!isInvisibleCalendar && (
            <div className="date-picker-wrapper ">
              <div className="date-picker" name="date-picker">
                <Calendar
                  navigationLabel={({ date, label, locale, view }) => `Select Delivery Date -  ${date.toLocaleString(locale, { month: "short" })}`}
                  className="order-calendar"
                  onClickDay={value => pickDeliveryDate(value)}
                  tileClassName={({ date, view }) => {
                    if (view !== 'month') return '';
                    const { enabled, now, old } = getDeliveryScheduleStatus(deliverySchedule, date);
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    const pickUpToday = addressType === 'pickUp' ? ((today.getTime() === date.getTime() && enabled) ? true : false) : false;
                    const isShownDate = isDateOfDeliveryWeeks(deliverySchedule, date);
                    // const isOnWeekDelivery = checkDayOnDeliveryWeek(deliverySchedule, date);
                    const className = compact([
                      'date',
                      'tile',
                      toISO(date) === toISO(currentDate) && 'active pro',
                      old && 'old',
                      now && 'now',
                      enabled && !pickUpToday && 'select',
                      (!enabled || old || pickUpToday) && `disabled ${(isConsumer || isPublic) ? 'consumer' : ''}`,
                      !isShownDate && 'hidden',
                    ]).join(' ');
                    return className;
                  }}
                  tileDisabled={({ date, view }) => {
                    if (view !== 'month') return false;
                    const { enabled, old } = getDeliveryScheduleStatus(deliverySchedule, date);
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    const pickUpToday = addressType === 'pickUp' ? ((today.getTime() === date.getTime() && enabled) ? true : false) : false;

                    return !enabled || old || pickUpToday;
                  }}
                  calendarType="US"
                  activeStartDate={activeStartDate}
                  value={currentDate}
                  showNeighboringMonth={false}
                />
              </div>
            </div>
          )} 
          {/* Totals */}
          <div>{totalInfo}</div>
        </div>
        { !isInvisibleCalendar && (
          <div className="titles" name="titles">
            {!noAutoPay && contact.netMode && contact.netMode === 'auto' && (
              <InvoiceBadge type="autopay">
                {formatMessage('C.O.D')}
              </InvoiceBadge>
            )}
            {!noAutoPay && contact.netMode && contact.netMode !== 'auto' && contact.netMode.startsWith('manual') && (
              <InvoiceBadge type="manualpay">
                {contact.netMode === 'manual-offline'
                  ? formatMessage('Pay Offline with Cash/Check')
                  : contact.netMode === 'manual'
                    ? formatMessage('Make one time payment')
                    : contact.netMode === 'manual-cod'
                      ? formatMessage('C.O.D')
                      : formatMessage('{mode}', { mode: startCase(contact.netMode.substr(6)) })
                }
              </InvoiceBadge>
            )}
            {
              isMobile && contact.defaultDeliveryFee > 0 && (
                <div className="d-flex discount-info d-md-up-none" style={{ alignItems: 'center', justifyContent: 'center' }}>
                  <LocalShipping style={{ color: 'rgba(0, 0, 0, 0.5' }} />&nbsp;
                  <span className="number">
                    ${contact.defaultDeliveryFee.toFixed(2)}&nbsp;
                  </span>
                </div>
              )
            }
            {
              isMobile && contact.defaultDiscount > 0 && (
                <div className="discount-info d-md-up-none">
                  <Tooltip tooltip={formatMessage('Discount')}>
                    <Badge type="discount">
                      -{contact.defaultDiscount}&nbsp;%
                    </Badge>
                  </Tooltip>
                </div>
              )
            }
            {!noAutoPay && contact.netMode && contact.netMode !== 'auto' && !contact.netMode.startsWith('manual') && (
              <InvoiceBadge type="autopay">
                {formatMessage('Auto Pay ({mode})', { mode: startCase(contact.netMode) })}
              </InvoiceBadge>
            )}

          </div>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(injectIntl(TopPanel));
